import { IIdentifiable } from '@/common/models/models'
import { IImage, Image } from '@/common/models/data/dashboard/media/image'
import { IPost, Post } from '@/common/models/data/dashboard/posts/post'

interface IGallery extends IIdentifiable {
    author: string
    title: string

    images?: Array<IImage>
    post?: IPost | null
}

class Gallery implements IGallery {
    id = 0
    author = ''
    title = ''

    images: Array<Image> = []

    post?: Post | null = null
    imageFiles: Array<File> = []

    constructor (dto?: IGallery) {
        if (dto) {
            this.id = dto.id
            this.author = dto.author
            this.title = dto.title

            this.images = dto.images?.map(image => new Image(image)) ?? []
            this.post = dto.post ? new Post(dto.post) : null
        }
    }
}

export {
    IGallery, Gallery
}
